'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  ADBLOCK_DETECTED: null,
  EXPIRATION_WARNING: null,
  EXPIRATION_ALERT: null,
  MULTI_EXPIRATION_WARNING: null,
  MULTI_EXPIRATION_ALERT: null,
  INACTIVE_ACCOUNT: null,
  ADWORDS_CREATED_SEARCH_CAMPAIGN: null,
  ADWORDS_CREATED_SHOPPING_CAMPAIGN: null,
  ADWORDS_CREATED_MOBILE_CAMPAIGN: null,
  FACEBOOK_AUDIENCE_TOS_CHANGED: null,
  APP_PERMISSIONS_ALERT: null,
  LEAD_SYNC_MISSING_EMAIL: null,
  LEAD_SYNC_ERROR_ALERT: null,
  LEAD_SYNC_WARNING_ALERT: null,
  COUPONS: null,
  ENHANCED_CONVERSIONS: null,
  FACEBOOK_CAPI_REPLACE_EVENTS: null
});